import {isEnvConfEnabled} from "../utils/env/isEnvConfEnabled";
import {ENV_CONFIG_VARIABLES} from "./env";

export const CONSTRUCTION_PHASE_BASIC_ACTIONS_COUNT =
  isEnvConfEnabled(ENV_CONFIG_VARIABLES.REACT_APP_ADDITIONAL_ACTIONS) ? 10 : 2;
export const CONSTRUCTION_PHASE_FIRST_ROUND_ADDITIONAL_ACTIONS = 2;

export const QUARTERS_OF_DIFFERENT_CITIES_MIN_HEXES_BETWEEN = 2;

export const CONSTRUCTION_ACTION_TYPES = {
  CONSTRUCTION: 'CONSTRUCTION',
  BUILDING_REPAIRMENT: 'BUILDING_REPAIRMENT'
}